module.exports = __webpack_public_path__ + "static/canada-479124ef639a3c5e4d23eb4bdb175312.png";